import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from "@angular/core";
import { Tour, TourStep, ViewConfiguration } from "./data";
import { LeafletMapComponent } from "map-wald-leaflet";

@Component({
  selector: 'tour',
  template: `
  <div class="btn-group">
    <button type="button" class="btn btn-primary" [disabled]="inProgress||step<=1" (click)="toStart()">
      <i class="fa fa-undo"></i>
    </button>
    <button type="button" class="btn btn-primary" [disabled]="inProgress||step<=1" (click)="move(-1)">
      <i class="fa fa-backward"></i>
    </button>
    <button type="button" class="btn btn-primary" [disabled]="inProgress||step>=tour?.steps?.length" (click)="move(1)">
      <i class="fa fa-forward"></i>
    </button>
    <button type="button" class="btn btn-primary" (click)="closed.emit()">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <ngb-alert *ngIf="currentStep" type="primary" [dismissible]="false">{{step}}/{{tour.steps.length}}: {{currentStep.label}}</ngb-alert>
`
})
export class TourComponent implements OnInit, OnChanges {
  @Input() tour:Tour;
  @Input() map:LeafletMapComponent;
  @Input() viewChangeCompleted: number;
  @Output() closed = new EventEmitter<void>();
  @Output() viewChanged = new EventEmitter<ViewConfiguration>();
  step=1;
  currentStep:TourStep;
  viewFromURL: TourStep;
  inProgress = false;

  constructor(){
    if(window.location.search){
      this.applyViewFromURL();
    }

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.viewChangeCompleted){
      this.inProgress=false;
    }
    if(changes.tour){
      if(this.viewFromURL){
        this.tour.steps.unshift(this.viewFromURL);
      }
      this.toStart();
    }

    if(changes.map){
      this.refresh();
      this.map.mapCreated.subscribe(()=>{
        setTimeout(()=>{
          console.log('map created');
          this.refresh();
        },250);
      });
    }
  }

  applyViewFromURL(): void {
    const view = new URLSearchParams(window.location.search);
    
    this.viewFromURL = {
      label: 'From URL',
      view: {}
    };

    for(const key of view.keys()) {
      let val:any = view.get(key);
      if(val==='true'){
        val = true;
      }else if(val==='false'){
        val = false;
      }else if(!isNaN(+val)){
        val = +val;
      }

      this.viewFromURL.view[key] = val;
    }
      //http://localhost:4200/?layer=Climate&variable=Precipitation&dataMode=Z Score&displayOpacity=50&lat=-25&lng=135&zoom=3&year=2022&month=6&window=3

  }

  toStart(): void {
    this.step = 1;
    this.refresh();
  }

  move(n:number):void {
    this.step += n;
    this.refresh();
  }

  refresh(): void {
    if(!this.map?.map){
      return;
    }

    setTimeout(()=>{
      this.currentStep = this.tour.steps[this.step-1];
      this.updateExtent();
      this.inProgress=true;
      this.viewChanged.emit(this.currentStep.view);
    });
  }

  updateExtent() {
    this.map.applyExtent(this.currentStep.view,true);
  }
}